module.exports = __webpack_public_path__ + "static/img/clothing_13.26bdb2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/inventory/stickers/clothing_13.png
// module id = +a/8
// module chunks = 0